import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { LiveProvider } from './context/LiveContext';
import { DataProvider } from './context/DataContext';
import AppShell from './components/layout/AppShell';
import Login from './pages/Login';

const Overview = lazy(() => import('./pages/Overview'));
const Fields = lazy(() => import('./pages/Fields'));
const FieldDetail = lazy(() => import('./pages/FieldDetail'));
const Stations = lazy(() => import('./pages/Stations'));
const Alerts = lazy(() => import('./pages/Alerts'));
const Live = lazy(() => import('./pages/Live'));
const Analytics = lazy(() => import('./pages/Analytics'));
const System = lazy(() => import('./pages/System'));
const Settings = lazy(() => import('./pages/Settings'));
const Help = lazy(() => import('./pages/Help'));
const NotFound = lazy(() => import('./pages/NotFound'));

export default function App() {
  const { user, ready } = useAuth();
  if (!ready) return <div className="empty" style={{ minHeight: '100vh' }}><div className="skeleton" style={{ width: 220, height: 18 }} /></div>;
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }
  return (
    <LiveProvider>
      <DataProvider>
        <Routes>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route element={<AppShell />}>
            <Route index element={<Overview />} />
            <Route path="fields" element={<Fields />} />
            <Route path="fields/:id" element={<FieldDetail />} />
            <Route path="stations" element={<Stations />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="live" element={<Live />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="system" element={<System />} />
            <Route path="settings" element={<Settings />} />
            <Route path="help" element={<Help />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </DataProvider>
    </LiveProvider>
  );
}
